import * as Sentry from "@sentry/react";

import { env } from "@/env";

export type ErrorContext = {
  tags?: Record<string, string>;
  extra?: Record<string, unknown>;
};

const ERROR_CONTEXT_KEY = "sentryContext";

export const attachErrorContext = <T extends Error>(error: T, context: ErrorContext): T => {
  return Object.assign(error, { [ERROR_CONTEXT_KEY]: context });
};

export const getErrorContext = (error: unknown): ErrorContext | undefined => {
  if (error instanceof Error && ERROR_CONTEXT_KEY in error) {
    return (error as Error & { [ERROR_CONTEXT_KEY]: ErrorContext })[ERROR_CONTEXT_KEY];
  }

  return undefined;
};

export const captureException = (error: unknown, context = getErrorContext(error)) => {
  if (env.VITE_APP_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(error, context);

    return;
  }

  if (!context) {
    Sentry.captureException(error);

    return;
  }

  Sentry.withScope((scope) => {
    scope.setTags(context.tags ?? {});
    scope.setExtras(context.extra ?? {});
    Sentry.captureException(error);
  });
};
